/**
* Description:
* This is component used to VSA EOM (End of month) Summary report for Admin
*
* Copyright:VSA & Samath IT Solutions
* Contact email: support@samath.com.au
*
* Authors:
* Hiro
*
* Date:20220205
*/

<template>
  <div>
    <div class="iq-card pl-3 pr-3 pt-5 pb-5">
      <div id="report-1" class="m-0 p-0">
        <div id="printBody">
          <table style="width: 100%">
            <tr>
              <table style="width: 100%; margin: 0; padding: 0">
                <tr>
                  <th style="width: 25%">
                    <div class="logo">
                      <img
                        src="../../../assets/images/vehicle-solutions-logo-type1.png"
                        class="img-fluid"
                      />
                    </div>
                  </th>
                  <th style="width: 75%">
                    <div class="text-right">
                      <h4
                        style="
                          color: #3f414d;
                          font-family: 'Roboto Condensed';
                          font-size: 3rem;
                          font-weight: 700;
                          line-height: 1;
                          margin-bottom: 0;
                        "
                      >
                        VSA EOM
                      </h4>
                      <h4
                        style="
                          color: #3f414d;
                          font-family: 'Roboto Condensed';
                          font-size: 3rem;
                          font-weight: 700;
                          line-height: 1;
                          margin-bottom: 0;
                        "
                      >
                        Summary
                      </h4>
                      <h4
                        style="
                          color: #3f414d;
                          font-family: 'Roboto Condensed';
                          font-size: 3rem;
                          font-weight: 700;
                          line-height: 1;
                          margin-bottom: 0;
                        "
                      >
                        Report
                      </h4>
                      <p
                        style="
                          font-weight: 700;
                          margin-top: 20px;
                          margin-bottom: 0;
                        "
                      >
                        {{ propsFromDate | dateConvertDDMMYYYY }} to
                        {{ propsToDate | dateConvertDDMMYYYY }}
                      </p>
                    </div>
                  </th>
                </tr>
              </table>
            </tr>

            <tr v-if="comGetRptData">
              <table
                style="width: 100%; margin: 0; padding: 0; margin-top: 25px"
              >
                <tr class="tbl-header-blue">
                  <th>Customer Name</th>
                  <th class="tbl-right">Net Ammount Leased</th>
                  <th class="tbl-right">Commission Inc GST</th>
                  <th class="tbl-right">GST</th>
                </tr>
                <tr class="tbl-tr-no-data">
                  <td colspan="4"></td>
                </tr>

                <template v-for="dealer in comGetRptData">
                  <tr class="tbl-header-gray">
                    <td colspan="4">
                      <span v-if="dealer[0].created_user"
                        >Finance Manager -
                        {{ dealer[0].created_user.firstName }} -
                        {{ dealer[0].dealer.name }}</span
                      >
                      <span v-else
                        >Finance Manager - {{ dealer[0].dealer.name }}</span
                      >
                    </td>
                  </tr>
                  <template v-for="record in dealer">
                    <tr class="tbl-border-bottom">
                      <td>
                        {{
                          record.client.firstName + ' ' + record.client.lastName
                        }}
                      </td>
                      <td class="tbl-right">
                        <!-- Net Amount leased -->
                        $ {{ record.totalDriveAwayCost | with-decimal}}
                      </td>
                      <td class="tbl-right">
                        <!-- Commission inc GST -->
                        $
                        {{ (Number(record.totalDriveAwayCost) * Number(record.dealerBrokerage)) |with-decimal}}
                      </td>
                      <td class="tbl-right" v-if="record.client_lookup_values">
                        <!-- GST -->
                        $
                        {{ ((Number(record.totalDriveAwayCost) * Number(record.dealerBrokerage)) / Number(11)) | with-decimal }}
                      </td>
                    </tr>
                  </template>
                  <tr class="tbl-tr-no-data">
                    <td colspan="4"></td>
                  </tr>
                </template>

                <tr>
                  <td></td>
                  <td></td>
                  <td class="tbl-right">Subtotal</td>
                  <td class="tbl-right">
                    $
                    {{ Number(comGetSubTotal) - Number(comGetGSTTotal) |with-decimal}}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="tbl-right">GST</td>
                  <td class="tbl-right">$ {{ comGetGSTTotal |with-decimal}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td class="tbl-right">GRAND TOTAL</td>
                  <td class="tbl-right">
                    $
                    {{ Number(comGetSubTotal) |with-decimal}}
                  </td>
                </tr>
              </table>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
@page {
  /* size: A4 portrait; */
  /* margin: 0cm 0cm; */
  width: 210mm;
  height: 290mm;
  margin: 0px 20px 0px 20px;
}
@media print {
  body * {
    visibility: hidden !important;
  }

  #reportConsoleLeftSide {
    display: none !important;
  }
  #reportConsoleRightSide.col-lg-8,
  #reportConsoleRightSide.col-md-8 {
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
  #report-1,
  #report-1 * {
    visibility: visible !important;
  }
  #report-1 {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    margin: 0;
  }
}
#report-1 .logo img {
  height: 125px !important;
  width: auto;
  border-radius: 0px;
}
#report-1 .img-fluid {
  max-width: 100% !important;
  height: auto !important;
}
#report-1 .tbl-header-blue {
  background-color: var(--iq-info);
  color: var(--iq-white);
}
#report-1 .tbl-header-gray {
  background-color: var(--iq-border-light);
  color: var(--iq-title-text);
}
#report-1 .tbl-header-blue th,
#report-1 .tbl-header-gray td,
#report-1 td {
  font-size: 1.1rem;
}
#report-1 tr th,
#report-1 tr td {
  padding: 15px;
}
#report-1 tr.tbl-tr-no-data td {
  padding: 10px;
}
#report-1 tr.tbl-tr-no-data30-gray td {
  padding: 30px;
  background-color: var(--iq-border-light);
}
#report-1 .tbl-border-bottom {
  border-bottom: 1px solid var(--iq-border-light);
}
#report-1 .tbl-border-bottom3 {
  border-bottom: 3px solid var(--iq-border-light);
}
#report-1 .tbl-border-bottom4 {
  border-bottom: 3px solid var(--iq-info);
}
#report-1 .tbl-left {
  text-align: left;
}
#report-1 .tbl-right {
  text-align: right;
}
#report-1 .tbl-center {
  text-align: center;
}

#report-1 .footer {
  position: relative;
  bottom: 0;
}

#report-1 tr td p {
  font-size: 1.1rem;
}
.bg-info {
  background-color: var(--iq-info);
}
.text-info {
  color: #38afef;
}
.fw-600 {
  font-weight: 600;
}
.mb-0 {
  margin-bottom: 0;
}
</style>
<script>
import * as authService from '../../../services/auth.service'
export default {
  name: 'VSAEOMSummaryReport',
  props: ['prosData', 'propsDealerIds', 'propsFromDate', 'propsToDate'],
  components: {},
  data() {
    return {
      userData: {},
      data: [],
      filterData: []
    }
  },
  computed: {
    comGetRptData() {
      let arr = this.prosData
      let groupBy = (array, key) => {
        return array.reduce((result, obj) => {
          ;(result[obj[key]] = result[obj[key]] || []).push(obj)
          return result
        }, {})
      }

      let sortFilter = (a, b) => {
        return a.client.dealerId - b.client.dealerId
      }

      let a = groupBy(arr.sort(sortFilter), 'createdBy')
      let b = Object.values(a)
      this.filterData = arr
      return b
    },
    comGetSubTotal() {
      let arr = this.filterData
      let totalPrice = arr.reduce((accumulator, item) => {
        return (
          accumulator +
          Number(item.totalDriveAwayCost) * Number(item.dealerBrokerage)
        )
      }, 0)
      return totalPrice
    },
    comGetGSTTotal() {
      let arr = this.filterData
      let gst = 0
      let totalGST = arr.reduce((accumulator, item) => {
        return (
          accumulator +
          (Number(item.totalDriveAwayCost) * Number(item.dealerBrokerage)) /
            Number(11)
        )
      }, 0)
      return totalGST
    }
  },
  methods: {
    fnPrintMe() {
      window.print()
    },
    fnPrintPage() {
      this.$htmlToPaper('report-1')
    }
  },
  created() {
    this.userData = authService.getUserFromToken()
  }
}
</script>